<template>
  <div>
    <el-dialog
      :title="(currentId ? '编辑' : '新建') + '代币'"
      :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item label="代币描述" required>
          <el-input v-model="form.title" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="金额" required>
          <el-input-number v-model="form.money" :precision="2" :step="0.1" :min="0.01"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="onSubmit">确 定</el-button>
      </div>
    </el-dialog>

    <commonTable
      ref="commonTable"
      url="admin/money_config/list"
      reqMethod="GET"
      :column="column"
      :searchColumn="searchColumn"
      limitKey="per_page"
    >
      <template slot="search" slot-scope="scope">
        <el-form-item>
          <el-button type="primary" @click="() => {
            form = {
              title: null,
              money: 0,
            }
            currentId = null
            dialogFormVisible = true
          }"
            >新建</el-button
          >
        </el-form-item>
      </template>
      <el-table-column label="操作" width="300" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="small"
            plain
            @click="() => {
              form = {
                title: scope.row.title,
                money: scope.row.money,
              }
              currentId = scope.row.id
              dialogFormVisible = true
            }"
            >编辑</el-button>
          <el-button
            type="danger"
            size="small"
            plain
            @click="onDel(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </commonTable>
  </div>
</template>

<script>
import fetch from "@/assets/js/axios.js"
import commonTable from '@/component/commonTable.vue'
export default {
  name: 'coinManager',
  components: {
    commonTable
  },
  data () {
    return {
      searchColumn: [
        {
          label: "商品描述",
          prop: "title",
          type: "input",
        },
      ],
      //代币
      form: {
        title: null,
        money: 0,
      },
      dialogFormVisible: false,
      currentId: null,
    }
  },
  computed: {
    column () {
      return [
        {
          label: "ID",
          prop: "id",
          fixed: true
        },
        {
          label: "商品描述",
          prop: "title",
          fixed: true
        },
        {
          label: "金额",
          prop: "money",
          formatter: (row, column, cellValue) => {
            return '￥' + cellValue
          }
        },
        {
          label: "时间",
          prop: "created_at",
        },
        {
          label: "操作人",
          prop: "admin.name"
        },
      ]
    },
  },
  mounted () {
  },
  methods: {
    onDel ({title, id}) {
      this.$confirm(`确定删除${title}吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        fetch({
          url: `admin/money_config/delete`,
          method: 'GET',
          params: { id },
        }).then(res => {
          if (res.data.status) {
            this.$message.success('删除成功')
            this.$refs.commonTable.reload()
          } else {
            this.$message.error(res.data.message)
          }
        })
      })
    },
    onSubmit () {
      const params = {
        ...this.form
      }
      if (this.currentId) params['id'] = this.currentId
      fetch({
        url: `/admin/money_config/${this.currentId ? 'update' : 'create'}`,
        method: 'GET',
        params,
      }).then(res => {
        if (res.data.status) {
          this.$message.success('操作成功')
          this.$refs.commonTable.reload()
          this.dialogFormVisible = false
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
.order-statistics {
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  padding-left: 0;
  color: rgba(0, 0, 0, 0.7);
  margin-bottom: 30px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  padding-left: 10px;
  list-style: none;
  li {
    margin-right: 30px;
  }
}

</style>
